/** @format */
import { localDateEditorModule } from './local-date-editor/localDateEditor/localDateEditor.component';
import { localDateRangeEditorModule } from './local-date-range-editor/localDateRangeEditor/localDateRangeEditor.dir';

export const commonDateModule = 'sis-components.date';

(function () {
    angular.module(commonDateModule, [
        'sis-components.date.constants',
        localDateEditorModule,
        localDateRangeEditorModule,
        'sis-components.date.localDateFormatFilter',
        'sis-components.date.previousDayFilter',
        'sis-components.date.yearRangeFilter',
        'sis-components.date.momentDateRangeFilter',
    ]);
})();
